module.exports = __webpack_public_path__ + "static/media/back_arrow.0bec07af.svg";